<script lang="ts" setup>
import WidgetLayout from './WidgetLayout.vue'

const { backgroundColor } = defineProps<{
  backgroundColor?: string
}>()
</script>

<template>
  <WidgetLayout :background-color="backgroundColor" class-name="!pb-4">
    <hr />
  </WidgetLayout>
</template>
